import { Copy } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CopyIcon = createLucideIcon(Copy);
